module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "content"
  }, [_vm._m(0), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addCity($event)
      }
    }
  }, [(_vm.errorMessage) ? _c('Message', {
    attrs: {
      "message-content": _vm.errorMessage,
      "message-status": "error"
    }
  }) : _vm._e(), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                City:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "name"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.city.name),
      expression: "city.name"
    }],
    attrs: {
      "name": "",
      "required": "",
      "placeholder": "Write a city name",
      "type": "text"
    },
    domProps: {
      "value": (_vm.city.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.city, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('fieldset', {
    staticClass: "form--item"
  }, [_c('label', {
    staticClass: "label",
    attrs: {
      "for": ""
    }
  }, [_vm._v("\n                Timezone:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input_text",
    attrs: {
      "id": "timezone"
    }
  }, [_c('v-select', {
    attrs: {
      "required": "",
      "searchable": false,
      "placeholder": "Click to select a Timezone",
      "options": _vm.timezones
    },
    model: {
      value: (_vm.city.timezone),
      callback: function($$v) {
        _vm.$set(_vm.city, "timezone", $$v)
      },
      expression: "city.timezone"
    }
  })], 1)]), _vm._v(" "), _vm._m(1)], 1), _vm._v(" "), _c('loading', {
    attrs: {
      "visible": _vm.loadingVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.loadingVisible = $event
      }
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('h1', [_vm._v("\n            Add new city\n        ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('button', {
    staticClass: "btn btn_blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Add city\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-68b2aa69", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b2aa69","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cities/AddCities.vue
// module id = 445
// module chunks = 1